import {NavigationPageEnum, NavigationPageType} from '../navigations.enums';
import {SettingsReferenceEnum} from '../../../settings-new/models';
import {
  _FEATURE_APPLICATION_PREFERENCES_DEFAULT,
  _FEATURE_AUTO_ORDERING_DEFAULT,
  _FEATURE_COPY_SETTINGS_DEFAULT,
  _FEATURE_EMAIL_DEFAULT,
  _FEATURE_LOCAL_STORAGE_DEFAULT,
  _FEATURE_SHELF_TALKERS_DEFAULT,
  _FEATURE_STOCK_RULES_DEFAULT,
  _FEATURE_STOCK_TAKE_DEFAULT,
  _FEATURE_USER_PROFILE_DEFAULT,
  _FEATURE_USER_TABLE_SETTINGS_DEFAULT,
  IFeatureApplicationPreferences,
  IFeatureAutoOrdering,
  IFeatureAutoOrderingOrderSettings,
  IFeatureBarcodeScanner,
  IFeatureCopySettings,
  IFeatureDashboard,
  IFeatureDashboardReporting,
  IFeatureEmail,
  IFeatureLabelMaker,
  IFeatureLocalStorage,
  IFeatureNGPReport,
  IFeatureNotifications,
  IFeatureShelfTalkers,
  IFeatureStaffAccess,
  IFeatureStockManager,
  IFeatureStockMaster,
  IFeatureStore,
  IFeatureStockRules,
  IFeatureStockTake,
  IFeatureUser,
  IFeatureUserProfile,
  IFeatureUserTable,
} from '..';

export interface IUserAccessFeature extends Object {
  displayText: string;
  feature: NavigationPageType;
  ref: SettingsReferenceEnum;
  standalone: boolean;
  disabled?: boolean;
  subFeatures?: IUserAccessSubFeatures[];
}

export type TFeatures =
  IFeatureApplicationPreferences
  | IFeatureAutoOrdering
  | IFeatureBarcodeScanner
  | IFeatureCopySettings
  | IFeatureDashboard
  | IFeatureDashboardReporting
  | IFeatureEmail
  | IFeatureLabelMaker
  | IFeatureLocalStorage
  | IFeatureNGPReport
  | IFeatureNotifications
  | IFeatureShelfTalkers
  | IFeatureStaffAccess
  | IFeatureStockManager
  | IFeatureStockMaster
  | IFeatureStore
  | IFeatureStockRules
  | IFeatureStockTake
  | IFeatureUser
  | IFeatureUserProfile
  | IFeatureUserTable;

export interface IUserAccessFeatures {
  [NavigationPageEnum.AutoOrdering]?: IFeatureAutoOrdering;
  [NavigationPageEnum.BarcodeScannerPageHome]?: IFeatureBarcodeScanner;
  [NavigationPageEnum.CopySettings]?: IFeatureCopySettings;
  [NavigationPageEnum.Dashboard]?: IFeatureDashboard;
  [NavigationPageEnum.DashboardReporting]?: IFeatureDashboardReporting;
  [NavigationPageEnum.Email]?: IFeatureEmail;
  [NavigationPageEnum.LabelMaker]?: IFeatureLabelMaker;
  [NavigationPageEnum.LocalStorage]?: IFeatureLocalStorage;
  [NavigationPageEnum.NGPReport]?: IFeatureNGPReport;
  [NavigationPageEnum.Notifications]?: IFeatureNotifications;
  [NavigationPageEnum.Preferences]?: IFeatureApplicationPreferences;
  [NavigationPageEnum.ShelfTalkers]?: IFeatureShelfTalkers;
  [NavigationPageEnum.StockManager]?: IFeatureStockManager;
  [NavigationPageEnum.StockMaster]?: IFeatureStockMaster;
  [NavigationPageEnum.StockRules]?: IFeatureStockRules;
  [NavigationPageEnum.StockTake]?: IFeatureStockTake;
  [NavigationPageEnum.Store]?: IFeatureStore;
  [NavigationPageEnum.TableSettings]?: IFeatureUserTable;
  [NavigationPageEnum.User]?: IFeatureUser;
  [NavigationPageEnum.UserAccess]?: IFeatureStaffAccess;
  [NavigationPageEnum.UserProfile]?: IFeatureUserProfile;
}

export interface IUserAccessSubFeatures {
  [NavigationPageEnum.AutoOrderingOrderSettings]?: IFeatureAutoOrderingOrderSettings;
}

export interface ISettingsState {
  account: IUserAccessFeatures;
  application: IUserAccessFeatures;
  features: IUserAccessFeatures;
  notifications: IUserAccessFeatures;
  security: IUserAccessFeatures;
}

/**
 * TODO: Only Add Each Feature they Have Access to and add it to this object.
 * No point in having each features settings set if they don't have access to it.
 */

export const _USER_ACCESS_ACCOUNT_DEFAULTS: IUserAccessFeatures = {
  [NavigationPageEnum.UserProfile]: {..._FEATURE_USER_PROFILE_DEFAULT},
  // [NavigationPageEnum.User]: {..._FEATURE_USER_DEFAULT},
};

export const _USER_ACCESS_APPLICATION_DEFAULTS: IUserAccessFeatures = {
  // [NavigationPageEnum.LocalStorage]: {..._FEATURE_LOCAL_STORAGE_DEFAULT},
  [NavigationPageEnum.Preferences]: {..._FEATURE_APPLICATION_PREFERENCES_DEFAULT},
  [NavigationPageEnum.TableSettings]: {..._FEATURE_USER_TABLE_SETTINGS_DEFAULT},
  // [NavigationPageEnum.Email]: {..._FEATURE_EMAIL_DEFAULT},
  // [NavigationPageEnum.Store]: {..._FEATURE_STORE_DEFAULT},
};


export const _USER_ACCESS_FEATURES_DEFAULTS: IUserAccessFeatures = {
  [NavigationPageEnum.AutoOrdering]: {..._FEATURE_AUTO_ORDERING_DEFAULT},
  [NavigationPageEnum.StockRules]: {..._FEATURE_STOCK_RULES_DEFAULT},
  [NavigationPageEnum.StockTake]: {..._FEATURE_STOCK_TAKE_DEFAULT},
  [NavigationPageEnum.ShelfTalkers]: {..._FEATURE_SHELF_TALKERS_DEFAULT},
  [NavigationPageEnum.CopySettings]: {..._FEATURE_COPY_SETTINGS_DEFAULT},
  // [NavigationPageEnum.BarcodeScannerPageHome]: {..._FEATURE_BARCODE_SCANNER_DEFAULT},
  // [NavigationPageEnum.Dashboard]: {..._FEATURE_DASHBOARD_DEFAULT},
  // [NavigationPageEnum.DashboardReporting]: {..._FEATURE_DASHBOARD_REPORTING_DEFAULT},
  // [NavigationPageEnum.LabelMaker]: {..._FEATURE_LABEL_MAKER_DEFAULT},
  // [NavigationPageEnum.NGPReport]: {..._FEATURE_NGP_REPORT_DEFAULT},
  // [NavigationPageEnum.StockManager]: {..._FEATURE_STOCK_MANAGER_DEFAULT},
  // [NavigationPageEnum.StockMaster]: {..._FEATURE_STOCK_MASTER_DEFAULT},
  // [NavigationPageEnum.Notifications]: {..._FEATURE_NOTIFICATIONS_DEFAULT},
};

export const _USER_ACCESS_NOTIFICATION_DEFAULTS: IUserAccessFeatures = {
  [NavigationPageEnum.Email]: {..._FEATURE_EMAIL_DEFAULT},
};

export const _USER_ACCESS_SECURITY_DEFAULTS: IUserAccessFeatures = {
  // [NavigationPageEnum.UserAccess]: {..._FEATURE_STAFF_ACCESS_DEFAULT},
};

export const _SETTINGS_STATE_DEFAULTS: ISettingsState = {
  account: _USER_ACCESS_ACCOUNT_DEFAULTS,
  application: _USER_ACCESS_APPLICATION_DEFAULTS,
  features: _USER_ACCESS_FEATURES_DEFAULTS,
  notifications: _USER_ACCESS_NOTIFICATION_DEFAULTS,
  security: _USER_ACCESS_SECURITY_DEFAULTS,
};
